import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { RadioSettings, ReportValidationType } from 'estensa-module';
import { firstValueFrom, from, Observable } from 'rxjs';

export const ESTENSA_MODULE_RADIO_SETTINGS_SERVICE = new InjectionToken('estensa.module.radio.settings.service');
export interface IRadioSettingsServiceNg1 {
    getAsJSON(): Promise<RadioSettings>;
    isExternalSigningEnabled(): boolean;
}

@Injectable({
    providedIn: 'root',
})
export class RadioSettingsService {
    private _radioSettings: RadioSettings | null = null;
    get radioSettings(): RadioSettings | null {
        return this._radioSettings;
    }

    get radioSettingsAsync(): Observable<RadioSettings> {
        return this.cacheService.get('RadioSettings', from(this.settingsService.getAsJSON()));
    }

    constructor(
        @Inject(ESTENSA_MODULE_RADIO_SETTINGS_SERVICE) private settingsService: IRadioSettingsServiceNg1,
        private cacheService: CacheService,
    ) {}

    async initService() {
        if (!this._radioSettings) {
            return firstValueFrom(this.radioSettingsAsync).then((settings) => {
                /*92337 fallback to ApproveAndSign*/
                const reportValidation = settings.reportValidation ?? ReportValidationType.ApproveAndSign;
                const cardioReportValidation = settings.cardioReportValidation ?? ReportValidationType.ApproveAndSign;
                settings.reportValidation = reportValidation;
                settings.cardioReportValidation = cardioReportValidation;
                this._radioSettings = settings;

                return settings;
            });
        }
    }

    canApprove(): boolean {
        return (
            !!this._radioSettings &&
            [ReportValidationType.OnlyApprove, ReportValidationType.ApproveAndSign].includes(
                this._radioSettings.reportValidation,
            )
        );
    }

    canApproveCardio(): boolean {
        return (
            !!this._radioSettings &&
            [ReportValidationType.OnlyApprove, ReportValidationType.ApproveAndSign].includes(
                this._radioSettings.cardioReportValidation,
            )
        );
    }

    canSign(): boolean {
        return (
            !!this._radioSettings &&
            [ReportValidationType.OnlySign, ReportValidationType.ApproveAndSign].includes(
                this._radioSettings.reportValidation,
            )
        );
    }

    canSignCardio(): boolean {
        return (
            !!this._radioSettings &&
            [ReportValidationType.OnlySign, ReportValidationType.ApproveAndSign].includes(
                this._radioSettings.cardioReportValidation,
            )
        );
    }

    isExternalSigningEnabled(): boolean {
        return this.settingsService.isExternalSigningEnabled();
    }
    enableExaminationChanges() {
        return this._radioSettings?.worklistSettings.enableExaminationChangesSettings;
    }

    enableAdmissionBookingChanges() {
        return this._radioSettings?.worklistSettings.enableAdmissionBookingChangesSettings;
    }
}
